/*
 * fly-to-cart - DESACTIVADO A PROPOSITO
 *
 * El original de Horizon hacia volar una copia de la foto del producto desde la
 * ficha hasta el icono del carrito al pulsar "anadir al carrito". Se quita para
 * que el cajon se abra directo, como hacia UpCart.
 *
 * El tema sigue insertando el elemento <fly-to-cart> al anadir al carrito, asi
 * que el componente tiene que seguir existiendo: lo unico que hace ahora es
 * quitarse del DOM sin animar nada. Si se borrara este fichero sin mas, el
 * import del tema fallaria.
 *
 * PARA RECUPERAR LA ANIMACION: copiar este mismo fichero desde el tema de
 * produccion, que conserva el original de Horizon.
 */

class FlyToCart extends HTMLElement {
  connectedCallback() {
    this.remove();
  }
}

if (!customElements.get('fly-to-cart')) {
  customElements.define('fly-to-cart', FlyToCart);
}
